// Страница «Настройки»: порядок и количество попыток дозвона по типам номеров

function getCsrfToken() {
  const input = document.querySelector('input[name="csrfmiddlewaretoken"]');
  if (input) return input.value;
  const match = document.cookie.match(/csrftoken=([^;]+)/);
  return match ? match[1] : '';
}

function showToast(message, isError = false) {
  const el = document.createElement('div');
  el.className = `fixed bottom-4 right-4 p-4 rounded-lg shadow-lg ${isError ? 'bg-red-600' : 'bg-green-600'} text-white z-50`;
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => {
    el.style.transition = 'opacity 0.5s';
    el.style.opacity = '0';
    setTimeout(() => el.remove(), 500);
  }, 3000);
}

function initRotationSettings() {
  const form = document.getElementById('rotation-settings-form');
  if (!form) return;

  const firstType = form.querySelector('#first_number_type');
  const secondType = form.querySelector('#second_number_type');
  const firstAttempts = form.querySelector('#first_attempts');
  const secondAttempts = form.querySelector('#second_attempts');
  const summary = document.getElementById('rotation-summary');
  const saveBtn = document.getElementById('rotation-save');
  const swapBtn = document.getElementById('rotation-swap');

  const GENITIVE = { mobile: 'мобильного', federal: 'федерального' };
  const genitive = (select) => GENITIVE[select.value] ?? select.value;

  // Первый и второй тип всегда разные: при выборе одного второй переключается автоматически
  function syncTypes(changed) {
    if (firstType.value !== secondType.value) return;
    const other = changed === firstType ? secondType : firstType;
    const alt = Array.from(other.options).find(o => o.value !== changed.value);
    if (alt) other.value = alt.value;
  }

  function renderSummary() {
    summary.textContent =
      `Сначала до ${firstAttempts.value} недозвонов с ${genitive(firstType)} номера, ` +
      `затем до ${secondAttempts.value} с ${genitive(secondType)}, ` +
      `после чего снова ${genitive(firstType)} номер.`;
  }

  [firstType, secondType].forEach(sel => sel.addEventListener('change', () => { syncTypes(sel); renderSummary(); }));
  [firstAttempts, secondAttempts].forEach(inp => inp.addEventListener('input', renderSummary));

  swapBtn?.addEventListener('click', () => {
    [firstType.value, secondType.value] = [secondType.value, firstType.value];
    [firstAttempts.value, secondAttempts.value] = [secondAttempts.value, firstAttempts.value];
    renderSummary();
  });

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const payload = {
      first_number_type: firstType.value,
      first_attempts: Number(firstAttempts.value),
      second_number_type: secondType.value,
      second_attempts: Number(secondAttempts.value),
    };
    saveBtn.disabled = true;
    fetch('/api/rotation_settings/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': getCsrfToken() },
      body: JSON.stringify(payload),
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || 'Не удалось сохранить настройки');
        return data;
      })
      .then(() => showToast('Настройки сохранены'))
      .catch((err) => showToast(err.message, true))
      .finally(() => { saveBtn.disabled = false; });
  });

  renderSummary();
}

document.addEventListener('DOMContentLoaded', initRotationSettings);
